import {Route, Routes} from 'react-router-dom';
import './App.css';
import {Batches} from './view/Batches';
import {Exceptions} from './view/Exceptions';


function App() {
  return (
    <div id="app_container">
      <Routes>
          <Route path="/local-clearance/batches" element={<Batches />} />
          <Route path="/local-clearance/exceptions" element={<Exceptions />} />
      </Routes>
    </div>
  )
}

export default App
